import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root"
})
export class ObtemDadosUsuario {
	async httpGet(theUrl) {
		var xmlHttp = new XMLHttpRequest();
		xmlHttp.open("GET", theUrl, false);
		xmlHttp.send(null);
		return xmlHttp.responseText;
	}

	public obterEnderecoIP(): Promise<any> {
		return this.httpGet("https://api.ipify.org");
	}
}
